import axios from "axios";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_URL } from "../../../config";

function UpdateDepartment() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [deptName, setDeptName] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${API_URL}/api/getDepartmentById/${id}`)
      .then((res) => {
        if (res.data) {
          setDeptName(res.data.deptName);
        }
      })
      .catch(() => {
        alert("Error fetching department details");
      });
  }, [id]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!deptName.trim()) {
      setError("Department name cannot be empty.");
      return;
    }
    setError("");
    try {
      const token = localStorage.getItem("token");

      await axios.put(
        `${API_URL}/api/updateDepartment/${id}`,
        { deptName },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Department updated successfully");
      navigate("/admin/department");
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data) {
        setError(error.response.data.message);
      } else {
        setError("Error updating department");
      }
    }
  };

  return (
    <div className="container py-5" style={{ background: "#f9faff", minHeight: "100vh" }}>
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <div className="card shadow-lg border-0 rounded-4">
            <div className="card-body p-4">
              <h3 className="fw-bold mb-4 text-center" style={{ color: "#1f3b98" }}>
                Update Department
              </h3>

              <form onSubmit={handleUpdate}>
                <div className="mb-3">
                  <label className="form-label fw-semibold">Department Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={deptName}
                    onChange={(e) => setDeptName(e.target.value)}
                    required
                  />
                  {error && <div className="text-danger mt-2">{error}</div>}
                </div>

                <div className="d-flex justify-content-between mt-4">
                  <button
                    type="button"
                    className="btn rounded-pill px-4 fw-semibold"
                    style={{
                      background: "linear-gradient(105deg, #c9d9ea, #c0d2e4 60%, #b5c9de)",
                      color: "#0b4f84",
                      border: "1px solid #a9c3dd",
                    }}
                    onClick={() => navigate("/admin/department")}
                  >
                    Back
                  </button>

                  <button
                    type="submit"
                    className="btn px-4 fw-bold rounded-pill"
                    style={{
                      background: "linear-gradient(105deg, #c9d9ea, #c0d2e4 60%, #b5c9de)",
                      color: "#0b4f84",
                      border: "1px solid #a9c3dd",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
                    }}
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateDepartment;
